import React from 'react';
import { Link } from 'react-router-dom';
import { LogIn, ShieldCheck } from 'lucide-react';
import { Button } from '../components/ui/button';
import { LOGO_URL } from '../mock';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function Login() {
  const handleLogin = () => {
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <section className="min-h-[80vh] bg-black text-white relative overflow-hidden flex items-center">
      <div className="absolute -top-32 -right-32 w-[440px] h-[440px] rounded-full bg-[#e11d2c]/20 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-32 -left-32 w-[440px] h-[440px] rounded-full bg-[#e11d2c]/10 blur-3xl pointer-events-none" />

      <div className="relative max-w-md mx-auto px-5 lg:px-8 w-full">
        <div className="bg-white/[0.06] backdrop-blur border border-white/10 rounded-2xl p-8 lg:p-10">
          <div className="flex justify-center">
            <img src={LOGO_URL} alt="Timeless Auto Imports" className="w-28 h-28 object-contain rounded-2xl" />
          </div>
          <h1 className="font-display text-[28px] font-black text-center mt-6">Sign in or create your account</h1>
          <p className="text-white/65 text-[14px] text-center mt-2">Track your orders, save vehicles &amp; parts to your watchlist, and check out faster. One click with Google — no passwords needed.</p>

          <Button onClick={handleLogin} data-testid="login-google-btn" className="btn-primary w-full mt-8 h-12 rounded-full bg-[#e11d2c] hover:bg-[#c01526] text-white font-semibold text-[14px]">
            <LogIn size={16} className="mr-2" /> Continue with Google
          </Button>

          <div className="mt-6 flex items-center gap-2 text-[12px] text-white/55 justify-center">
            <ShieldCheck size={13} className="text-[#e11d2c]" /> Secure Google OAuth &middot; Staff use the same sign-in
          </div>

          <Link to="/" className="block text-center mt-6 text-white/65 text-[13px] hover:text-white">← Back to website</Link>
        </div>
      </div>
    </section>
  );
}
